export default "__VITE_ASSET__CYl_ZryR__"